module.exports = __webpack_public_path__ + "static/img/lineChart.28c4fd49.svg";